import React, { useContext } from 'react';

import { MenuItem } from '@material-ui/core';
import { updateTaskTeamAction } from 'actions/task';
import CustomMenu, { DropdownContext } from 'components/CustomMenu';
import { ScrollableContainer } from 'screens/Team/TeamPageFilters/styles';
import styled from 'styled-components';
import { StyledTooltip, StyledTypography, NewStyledIconButton } from 'styles/common';

import { getColorFromKey } from 'constants/helper';
import { GroupIcon } from 'constants/icons';
import theme from 'constants/theme';

import MeshListContext from '../MeshListContext';

const Container = styled(NewStyledIconButton)`
  height: 22px;
  width: 22px;
  border: 1px solid ${(props) => getColorFromKey(props.color || props.theme.palette.text.secondary)};
  background-color: white;
  svg {
    fill: #999;
  }
  &:hover {
    border-color: ${getColorFromKey('primary')};
    svg {
      fill: ${getColorFromKey('primary')};
    }
  }
`;

export default function TaskEditTeamComponent({ taskId, taskKey, selectedTeam, teams }) {
  const selectedTeamId = selectedTeam?.id;
  const { dispatch } = useContext(MeshListContext);
  return (
    <div>
      <CustomMenu
        icon={
          <span>
            <StyledTooltip title={selectedTeam?.name || 'Add team'}>
              <span>
                <Container color="#999" circular>
                  <GroupIcon size="tinier" color={theme.palette.icons.black2} />
                </Container>
              </span>
            </StyledTooltip>
          </span>
        }
      >
        <TeamsDropdown teams={teams} taskId={taskId} taskKey={taskKey} dispatch={dispatch} />
      </CustomMenu>
    </div>
  );
}

function TeamsDropdown({ teams, taskId, taskKey, dispatch }) {
  const { handleClose } = useContext(DropdownContext);
  function onMenuItemClick(e, team) {
    dispatch(updateTaskTeamAction({ id: taskId, key: taskKey, team }));
    handleClose(e);
  }
  return (
    <CustomMenu.DropdownList>
      <ScrollableContainer>
        {teams.map((team, index) => (
          <MenuItem onClick={(e) => onMenuItemClick(e, team)}>
            <StyledTypography display="inline">{team.name}</StyledTypography>
          </MenuItem>
        ))}
      </ScrollableContainer>
    </CustomMenu.DropdownList>
  );
}
